// More page — destination for the 5th bottom-nav slot on mobile / tablet.
// Per atlas-mobile-DESIGN.md §3 "More — contents and ordering".

import { More } from '@/v2/v3/More'

// v3 rebuild: /more renders the v3 More screen (clean routed list, shared
// shell). The legacy AppLayout-based body was trimmed in the B4 cleanup —
// see git history.
export function V2MorePage() {
  return <More />
}
